<template>
  <div>
    <div class="flex items-center text-sm items-center justify-between">
      <div class="flex items-center">
        <InfoIcon class="mr-2 text-grey-600 h-4 w-4"/>
        {{ $t('frontend_groovemail_campains_index_you_dont') }}
      </div>
      <div class="flex items-center">
        <div
          class="text-sm text-primary cursor-pointer font-bold mr-6"
          @click="openCreateEmailSender"
        >
          {{ $t('frontend_create') }}
          {{ $t('frontend_groovemail_settings_sender_settings') }}
        </div>
        <div
          class="text-sm text-primary cursor-pointer font-bold mr-6"
          @click="openCreateSmsSender"
        >
          {{ $t('frontend_create') }}
          {{ $t('frontend_groovemail_campaigns_sms_sender_label') }}
        </div>
        <span class="cursor-pointer" @click="closeSenderBanner()">
          <CloseIcon class="text-grey-700 h-6 w-6"/>
        </span>
      </div>
    </div>
    <gd-modal
      id="create-email-sender-wrapper"
      name="create-email-sender-modal"
      :title="this.$t('frontend_groovemail_settings_sender_settings')"
    >
      <VuePerfectScrollbar>
        <div class="scroll-modal-tab">
          <create-email-sender
            ref="createEmailSender"
            @emailSenderCreated="emailSenderCreated"
          >
          </create-email-sender>
          <div class="flex justify-end p-6 pt-0">
            <gd-button
              size="auto"
              @click="closeCreateEmailSender"
              >{{ $t('frontend_cancel') }}</gd-button
            >
            <gd-button
              variant="primary"
              size="auto"
              @click="createNewEmailSender"
              class="ml-2"
              >{{
                this.$t('frontend_groovemail_create_sender_route_page_title')
              }}</gd-button
            >
          </div>
        </div>
      </VuePerfectScrollbar>
    </gd-modal>
    <gd-modal
       
      id="create-sms-sender-wrapper"
      name="create-sms-sender-modal"
      :title="this.$t('frontend_groovemail_settings_integeration_settings')"
    >
      <VuePerfectScrollbar>
        <div class="scroll-modal-tab">
          <create-sms-sender
            ref="createSmsSender"
            @smsSenderCreated="smsSenderCreated"
          >
          </create-sms-sender>
          <div class="flex justify-end p-6 pt-0">
            <gd-button
              size="auto"
              @click="closeCreateSmsSender"
              >{{ $t('frontend_cancel') }}</gd-button
            >
            <gd-button
              variant="primary"
              size="auto"
              @click="createNewSmsSender"
              class="ml-2"
              >{{
                this.$t('frontend_groovemail_create_sender_route_page_title')
              }}</gd-button
            >
          </div>
        </div>
      </VuePerfectScrollbar>
    </gd-modal>
  </div>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import CreateSmsSender from '@/pages/settings/create_integeration.vue';
import CreateEmailSender from '@/pages/settings/create.vue';

// import icons
import InfoIcon from '@/assets/images/icons/new/info_new.svg';
import CloseIcon from '@/assets/images/icons/new/close_small_new.svg';

const axios = require('axios');

export default {
  middleware: 'auth',

  components: {
    VuePerfectScrollbar,
    CreateSmsSender,
    CreateEmailSender,
    InfoIcon,
    CloseIcon,
  },

  methods: {
    async createNewEmailSender() {
      await this.$refs.createEmailSender.createNewSender();
    },

    async emailSenderCreated() {
      this.$root.$emit('modal-close', 'create-email-sender-modal');
    },

    openCreateEmailSender() {
      this.$root.$emit('modal-open', 'create-email-sender-modal');
    },

    closeCreateEmailSender() {
      this.$root.$emit('modal-close', 'create-email-sender-modal');
    },

    async createNewSmsSender() {
      await this.$refs.createSmsSender.createNewSmsSender();
    },

    async smsSenderCreated() {
      this.$emit('smsSenderCreated');
      this.$root.$emit('modal-close', 'create-sms-sender-modal');
    },

    openCreateSmsSender() {
      this.$root.$emit('modal-open', 'create-sms-sender-modal');
    },

    closeCreateSmsSender() {
      this.$root.$emit('modal-close', 'create-sms-sender-modal');
    },

    closeSenderBanner() {
      this.$emit('closeSenderBanner');
    },
  },
};
</script>

<style lang="scss">
#create-email-sender-wrapper {
  .create-sender-save-btn,
  .create-sender-header {
    display: none;
  }
  .new-add-btn {
    font-size: 16px;
  }
}

#create-sms-sender-wrapper {
  .sms-sender-phone-input {
    color: #8689a4;
  }
  .create-sender-save-btn,
  .create-sender-header {
    display: none;
  }
  .new-add-btn {
    font-size: 16px;
  }
}
</style>
